import { AuditQuestionTypeEnum } from 'modules/audits/types/resources/audits.enum';

export const AUDIT_MODEL_STATUS = {
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  DEPRECATED: 'DEPRECATED'
};

export const HINT_MAX_LENGTH = 1000;

export const AUDIT_MODELS_LIST_TYPE = {
  MY: 'MY',
  AVAILABLE: 'AVAILABLE'
};

export const SUBJECTABLE_QUESTIONS = [
  AuditQuestionTypeEnum.RADIO_BUTTON,
  AuditQuestionTypeEnum.DATETIME,
  AuditQuestionTypeEnum.EXPLODED_VIEW,
  AuditQuestionTypeEnum.TEXTBOX,
  AuditQuestionTypeEnum.EMAIL
];

export const COPY_SUFFIX_TRANSLATION_KEY = 'auditModels.duplicate.copySuffix';

export const MANDATORY_QUESTIONS = [AuditQuestionTypeEnum.REFERENCE, AuditQuestionTypeEnum.AUTHOR];

export const QuestionTypeMapping = {
  multipleChoices: AuditQuestionTypeEnum.CHECKBOX,
  singleChoice: AuditQuestionTypeEnum.RADIO_BUTTON,
  freeText: AuditQuestionTypeEnum.TEXTBOX,
  email: AuditQuestionTypeEnum.EMAIL,
  media: AuditQuestionTypeEnum.MEDIA,
  yesNo: AuditQuestionTypeEnum.YES_NO,
  barcode: AuditQuestionTypeEnum.BARCODE,
  datetime: AuditQuestionTypeEnum.DATETIME,
  padsThickness: AuditQuestionTypeEnum.PADS_THICKNESS,
  number: AuditQuestionTypeEnum.NUMBER,
  severity: AuditQuestionTypeEnum.SEVERITY,
  thickness: AuditQuestionTypeEnum.THICKNESS,
  employee: AuditQuestionTypeEnum.EMPLOYEE,
  multiEmployee: AuditQuestionTypeEnum.MULTI_EMPLOYEE,
  signature: AuditQuestionTypeEnum.SIGNATURE,
  explodedView: AuditQuestionTypeEnum.EXPLODED_VIEW,
  brand: AuditQuestionTypeEnum.BRAND,
  kpiQuestion: AuditQuestionTypeEnum.KPI,
  tireReport: AuditQuestionTypeEnum.TIRE_REPORT,
} as const satisfies Record<string, AuditQuestionTypeEnum>;

export type QuestionTypeMapping = typeof QuestionTypeMapping[keyof typeof QuestionTypeMapping];
export type QuestionTypeMappingKey = keyof typeof QuestionTypeMapping;
